export default function initials(name) {
  return name
    .trim()
    .split(/\s/)
    .reduce((result, s, i, arr) => {
      if (i === 0) {
        return [(s[0] || '').toUpperCase()]
      }

      if (i === arr.length - 1) {
        return [...result, (s[0] || '').toUpperCase()]
      }
      return result
    }, [])
    .join('')
}
